"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _icon = _interopRequireDefault(require("../icon"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

var _messages = _interopRequireDefault(require("./messages"));

var _style = _interopRequireDefault(require("./style.css"));

var _this3 = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var RenderList = /*#__PURE__*/function (_PureComponent) {
  _inherits(RenderList, _PureComponent);

  var _super = _createSuper(RenderList);

  function RenderList() {
    var _this;

    _classCallCheck(this, RenderList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: false
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVisible", function () {
      return _this.setState({
        visible: !_this.state.visible
      });
    });

    return _this;
  }

  _createClass(RenderList, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;

      var recursiveEach = function recursiveEach(options) {
        return options.map(function (option) {
          option.options && recursiveEach(option.options);
          option.checked && _this2.setState({
            visible: true
          });
        });
      };

      this.props.item.options && recursiveEach(this.props.item.options);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          item = _this$props.item,
          depLevel = _this$props.depLevel,
          allowMultiSelect = _this$props.allowMultiSelect,
          allowSelectNestedFolder = _this$props.allowSelectNestedFolder,
          handleChange = _this$props.handleChange,
          disabled = _this$props.disabled;
      var isNested = item.options && item.options.length > 0;
      return /*#__PURE__*/_jsx("li", {}, void 0, /*#__PURE__*/_jsx("div", {
        className: cx('xsui-tree-select__item'),
        style: {
          paddingLeft: 12 * (depLevel + 1) + 12 * depLevel
        }
      }, void 0, isNested && /*#__PURE__*/_jsx(ArrowTrigger, {
        open: this.state.visible,
        label: item.label,
        onClick: this.toggleVisible,
        dataId: "".concat(item.id, ".arrow")
      }), !isNested || allowSelectNestedFolder ? /*#__PURE__*/_jsx("div", {
        className: cx('xsui-tree-select__item__entry')
      }, void 0, /*#__PURE__*/_jsx(_checkbox["default"], {
        appearance: allowMultiSelect ? 'primary' : 'flatten',
        input: {
          name: "".concat(item.id, ".checkbox"),
          value: item.checked,
          onChange: handleChange.bind(this, item, false)
        },
        disabled: item.disabled || disabled,
        label: item.label
      }), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-tree-select__item__entry__extra')
      }, void 0, item.extraLabel)) : /*#__PURE__*/_jsx("div", {
        className: cx('xsui-tree-select__item__entry')
      }, void 0, /*#__PURE__*/_jsx("div", {}, void 0, item.label), /*#__PURE__*/_jsx("div", {
        className: cx('xsui-tree-select__item__entry__extra')
      }, void 0, item.extraLabel))), this.state.visible && isNested && /*#__PURE__*/_jsx("ul", {}, void 0, item.options.map(function (option, index) {
        return /*#__PURE__*/_jsx(RenderList, {
          item: option,
          depLevel: depLevel + 1,
          allowMultiSelect: allowMultiSelect,
          allowSelectNestedFolder: allowSelectNestedFolder,
          handleChange: handleChange,
          disabled: disabled
        }, index);
      })));
    }
  }]);

  return RenderList;
}(_react.PureComponent);

var _ref2 = /*#__PURE__*/_jsx(_icon["default"], {
  name: "expand"
});

var ArrowTrigger = function ArrowTrigger(_ref) {
  var open = _ref.open,
      dataId = _ref.dataId,
      rest = _objectWithoutProperties(_ref, ["open", "dataId"]);

  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__arrow-trigger', open && 'xsui-tree-select__arrow-trigger--open')
  }, void 0, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cx('xsui-tree-select__arrow-trigger__icon'),
    "data-id": dataId,
    "data-value": open
  }, rest), _ref2));
};

var Entries = function Entries(_ref3) {
  var intl = _ref3.intl,
      value = _ref3.value,
      options = _ref3.options,
      _ref3$appearance = _ref3.appearance,
      appearance = _ref3$appearance === void 0 ? 'primary' : _ref3$appearance,
      _ref3$showStripes = _ref3.showStripes,
      showStripes = _ref3$showStripes === void 0 ? true : _ref3$showStripes,
      allowMultiSelect = _ref3.allowMultiSelect,
      allowSelectNestedFolder = _ref3.allowSelectNestedFolder,
      customStatusLabel = _ref3.customStatusLabel,
      handleChange = _ref3.handleChange,
      handleSelectAll = _ref3.handleSelectAll,
      handleUnselectAll = _ref3.handleUnselectAll,
      placeholder = _ref3.placeholder,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      entryMaxHeight = _ref3.entryMaxHeight;
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__entries')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__entries__head')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__entries__head__count')
  }, void 0, intl.formatMessage(customStatusLabel || _messages["default"].selectedItems, {
    count: value.length,
    total: options.length
  })), allowMultiSelect && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__entries__head__action', disabled && 'xsui-tree-select__entries__head__action--disabled')
  }, void 0, value.length === 0 ? /*#__PURE__*/_jsx("span", {
    onClick: handleSelectAll.bind(_this3)
  }, void 0, intl.formatMessage(_messages["default"].selectAll)) : /*#__PURE__*/_jsx("span", {
    onClick: handleUnselectAll.bind(_this3)
  }, void 0, intl.formatMessage(_messages["default"].unselectAll)))), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__entries__content', "xsui-tree-select__entries__content--appearance-".concat(appearance), showStripes && 'xsui-tree-select__entries__content--with-stripes'),
    style: {
      maxHeight: entryMaxHeight
    }
  }, void 0, !options.length && placeholder ? /*#__PURE__*/_jsx("div", {
    className: cx('xsui-tree-select__entries__content__placeholder')
  }, void 0, placeholder) : /*#__PURE__*/_jsx("ul", {}, void 0, options.map(function (option, index) {
    return /*#__PURE__*/_jsx(RenderList, {
      item: option,
      depLevel: 0,
      allowMultiSelect: allowMultiSelect,
      allowSelectNestedFolder: allowSelectNestedFolder,
      handleChange: handleChange,
      disabled: disabled
    }, index);
  }))));
};

var _default = (0, _reactIntl.injectIntl)(Entries);

exports["default"] = _default;